<template>
   <div class="stage-info-wrapper">
      <h2 class="stage-info-title">{{ title }}</h2>
      <p class="stage-info-content">{{ info }}</p>
   </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
   props: {
      stage: Number,
   },

   computed: {
      ...mapGetters({isAppConfigured: 'isAppConfigured'}),
      title() {
         switch (this.stage) {
            case 1:
               return 'Permitted Purpose';
            case 2:
               return 'Technological in Nature';
            case 3:
               return 'Elimination of Uncertainty';
            case 4:
               return 'Process of Experimentation';
            case 5:
               return 'Conclusion';
            default:
               return '';
         }
      },

      info() {
         switch (this.stage) {
            case 1:
               return 'To qualify for R&D credit, the purpose of the effort must be to achieve a new or improved product or process. The product or process must provide new or improved functionality, performance, reliability, scalability, and/or overall increase in quality. Efforts with this purpose will qualify, whereas simple aesthetic changes, for example, will not.';
            case 2:
               return "Your company's development efforts must fundamentally rely on a hard science to qualify as research & development. Efforts that apply engineering disciplines, physics, chemistry, biological science, software engineering, material science, food science, etc. will qualify, whereas soft sciences such as marketing research, sociology, psychology will not.";
            case 3:
               return 'In order to meet the Elimination of Uncertainty criteria, there must be technical uncertainties or challenges encountered at the onset or throughout the initiative. Uncertainties concerning capability, optimal methodology, or appropriate design of the development or improvement initiatives will likely qualify. Simple fixes, routine repairs & maintenance, or routine production will not.';
            case 4:
               return 'Finally, your research & development team must be able to demonstrate that the R&D efforts utilized a process which included the evaluation of potential alternatives to achieve the desired outcome. This could include conducting systematic trial-and-error, prototyping and first article development, modeling, or testing to validate design hypotheses and concepts in order to arrive at a final design. A process that did not involve experimentation will not qualify.';
            case 5:
               if (this.isAppConfigured) {
                  return "Now that you understand what qualifies as R&D, head over to the Onboard Dashboard, your hub for seeing what tasks you have left to complete in the process of providing your company's R&D information. You can come back to this section any time for a refresher on the Four-Part Test.";
               }
               return "Now that you understand what qualifies as R&D, let's get your tax credit study started.";
            default:
               return '';
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.stage-info-title {
   font-size: 1.25rem;
   font-weight: 700;
   padding-bottom: 2rem;
   color: $secondary;
}

.stage-info-content {
   font-size: 0.8125rem;
   font-weight: 500;
   color: $secondary;
}

.stage-info-wrapper {
   padding-top: 4.375rem;
   padding-bottom: 4.375rem;
}
</style>
